module.exports = __webpack_public_path__ + "static/img/SW3.85aeec65.png";